export const DEFAULT_IMAGES = [
  "https://images.unsplash.com/photo-1591291413979-ec06c29545a1?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
];

export const getRandomDefaultImg = () => {
  const index = Math.floor(Math.random() * DEFAULT_IMAGES.length);
  return DEFAULT_IMAGES[index];
};

export function formatViews(num) {
  if (num == null) return "0";

  const n = typeof num === "bigint" ? Number(num) : Number(num);

  if (isNaN(n)) return "0";

  if (n >= 1_000_000_000_000) {
    return (n / 1_000_000_000_000).toFixed(1).replace(/\.0$/, "") + "T";
  }
  if (n >= 1_000_000_000) {
    return (n / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  }
  if (n >= 1_000_000) {
    return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (n >= 1_000) {
    return (n / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return n.toString();
}

export const slugify = (text) => {
  if (!text) return "";
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[\s\p{P}]+/gu, "-")
    .replace(/(^-|-$)/g, "");
};

export const normalizeImageUrl = (url: string | null | undefined): string | null => {
  if (!url) return null;
  return url;
};
